import React, { useState } from "react";
import { Modal, Form, Button, ListGroup } from "react-bootstrap";
import { ResumeDetails } from "../../store/resume.store";
import { showError } from "../../utils/Common";

const ResumeListModal = ({
  showWork,
  handleCloseWK,
  resumeList,
  onSelectUsers,
}: any) => {
  const [selectedUsers, setSelectedUsers] = useState<ResumeDetails[]>([]);

  // const handleUserSelect = (user: ResumeDetails, index: number) => {
  //   setSelectedUsers((prevSelected) => {
  //     if (prevSelected.includes(index)) {
  //       // If already selected, remove from the selection
  //       return prevSelected.filter((id) => id !== index);
  //     } else {
  //       // Add to the selection
  //       return [...prevSelected, index];
  //     }
  //   });
  // };

  const handleUserSelect = (user: ResumeDetails, index: number) => {
    setSelectedUsers((prevSelected) => {
      const isSelected = prevSelected.some(
        (selectedUser) =>
          selectedUser.email === user.email && selectedUser._id === user._id
      );
      if (isSelected) {
        // If already selected, remove from the selection
        return prevSelected.filter(
          (selectedUser) =>
            selectedUser.email !== user.email || selectedUser._id !== user._id
        );
      } else {
        // Add the full user object to the selection
        return [...prevSelected, user];
      }
    });
  };

  const handleBulkSubmit = () => {
    if(selectedUsers?.length>0)
    {
      onSelectUsers(selectedUsers); // Pass selected users to parent or API
      handleCloseWK(); // Close modal after selection
    }
    else
    {
      showError(`Please select resume to proceed`);
    }
  };

  return (
    <Modal
      show={showWork}
      onHide={handleCloseWK}
      animation={false}
      aria-labelledby="contained-modal-title-vcenter"
      className="editPersonalInformation"
      centered
    >
      <Modal.Body>
        <div className="findbody">
          <h3>Select Users</h3>
          <ListGroup className="selectUserslist">
            {resumeList &&
              resumeList?.map((user: ResumeDetails, index: number) => (
                <ListGroup.Item key={index}>
                  <Form.Check
                    type="checkbox"
                    label={`${user.name} `}
                    checked={selectedUsers.includes(user)}
                    onChange={() => handleUserSelect(user, index)}
                  />
                </ListGroup.Item>
              ))}
          </ListGroup>
          <div className="d-flex gp-10">
            <Button className="btn btn-black w-100" onClick={handleBulkSubmit}>
              Select and Upload
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ResumeListModal;
